/**
 * Gets the pixels within the square.
 * @export @public @method
 * @name getSquare
 *
 * @param  {number} radius     The radius of the square.
 * @param  {number} rows       The number of rows.
 * @param  {number} columns    The number of columns.
 * @param  {number} [xCoord = 0] The x-location of the center of the square.
 * @param  {number} [yCoord = 0] The y-location of the center of the square.
 * @param  {number} scale Thickness of the image.
 * @returns {Array.number[]}        Array of pixels contained within the square.
 */
export default function getSquare(
  radius,
  rows,
  columns,
  xCoord = 0, // NOSONAR
  yCoord = 0, // NOSONAR
  scale
) {
  const x0 = Math.floor(xCoord);
  const y0 = Math.floor(yCoord);

  if (radius === 1) {
    return [[x0, y0]];
  }

  const squareArray = [];
  let index = 0;

  const rowRadius = rows < columns ? radius * scale : radius;
  const columnRadius = columns < rows ? radius * scale : radius;

  for (let y = -rowRadius; y <= rowRadius; y++) {
    const yCoord = Math.round(y0 + y); // NOSONAR
    if (yCoord > rows || yCoord < 0) {
      continue;
    }
    for (let x = -columnRadius; x <= columnRadius; x++) {
      const xCoord = Math.round(x0 + x); // NOSONAR
      if (xCoord >= columns || xCoord < 0) {
        continue;
      }
      squareArray[index++] = [xCoord, yCoord];
    }
  }

  return squareArray;
}
